var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"modal",staticClass:"modal",class:{ 'no-content': _vm.noContent },on:{"click":function($event){return _vm.filterClose($event)}}},[_c('transition',{attrs:{"mode":"out-in"}},[_c(_vm.component,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }